import React, { Component } from 'react';
import { Row, Col, Tag, Popconfirm, Button, Alert } from 'antd';
import { Menu as MenuApi, Customer } from '../../../../services/api';
import SaveMenu from './SaveMenu'
import Week from './Week';
import Spinner from '../../../../components/Spinner';

export default class CustomerMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            menu: { 
                origin: { _embedded: { 'varma:days': { data: [] } } }, 
                weeks: [] 
            },
            customer: {},
            menus: [],
            loading: {
                menu: false,
                delete: false,
                customer: false
            }
        };
    
        this.customerApi = new Customer(props);
        this.menuApi = new MenuApi(props);
    }

    componentDidMount() {
        this.fetchMenu();
        this.fetchCustomer();
        
    }

    fetchCustomer = () => {
        const { loading } = this.state;
        const state = this.props.location.state;

        if (state && state.customer) {
            this.setState({ customer: state.customer });
            if (state && state.menus) {
                this.setState({ menus: state.menus });
            } else {
                this.listMenus();
            }
            return;
        }

        loading.customer = true;
        this.setState({ loading });
        this.customerApi.me()
            .then(res => {
                this.setState({ customer: res.data.data });
                this.listMenus();
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.fetchCustomer });
            });
    }

    listMenus = () => {
        const { customer, loading } = this.state;

        this.customerApi.raw().get(customer._links.menus.href)
            .then(res => {
                loading.customer = false;
                this.setState({ loading, menus: res.data.data });
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.listMenus });
            });
    }

    fetchMenu = () => {
        const { loading } = this.state;
        const { state } = this.props.location;
        
        if (state && state.menu) {
            this.setState({ menu: state.menu });
            return;
        }
        
        loading.menu = true;
        this.setState({ loading });

        this.customerApi.findMenu(this.props.match.params.id, this.props.match.params.menuId)
            .then(res => {
                this.fetchOrigin(res.data.data);
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.fetchMenu });
            });
    }

    fetchOrigin = (menu) => {
        const { loading } = this.state;
        this.menuApi.raw().get(menu._links.origin.href)
            .then(res => {
                menu.origin = res.data.data;
                loading.menu = false;
                this.setState({ loading, menu: menu });
            })
            .catch(_ => {
                this.menuApi.retry({ params: [menu], cb: this.fetchOrigin });
            });
    }

    delete = (menu) => {
        const { loading } = this.state;
        loading.delete = true;
        this.setState({ loading });

        this.customerApi.raw().delete(menu._links.delete.href)
            .then(() => {
                loading.delete = false;
                this.setState({ loading });
                this.props.history.push('/menus');
            })
            .catch(_ => {
                this.customerApi.retry({ params: [menu], cb: this.delete });
            });
    }

    menuEdited = (menu) => {
        this.props.history.replace({
            state: { menu: menu }
        });
        
        this.setState({ menu: menu });
    }

    render() {
        const { menu, menus, customer, loading } = this.state;

        return (
            <Row type="flex" align="middle">
                <Col xs={24} md={12}>
                    <h2 style={{ fontSize: '30px', marginBottom: '5px' }}>{menu.origin.title}</h2>
                </Col>

                <Col xs={24} md={12}>
                    <Popconfirm
                        title={`Är du säker på att du vill radera: ${menu.origin.title}`}
                        onConfirm={() => { this.delete(menu) }}
                        cancelText="Nej"
                        okText="Ja"
                    >
                        <Button className="menu-action-btn" type="danger" icon={loading.delete ? 'loading' : 'delete' } loading={loading.delete}>
                            Radera
                        </Button>  
                    </Popconfirm>
                    <SaveMenu 
                        className="menu-action-btn"
                        editing
                        weeks={menu.weeks}
                        menu={menu.origin}
                        customerMenu={menu}
                        allocatedWeeks={menus.length > 0 && menus.map(m => m.weeks).reduce((prev, curr) => prev.concat(curr))}
                        customer={customer}
                        onSave={this.menuEdited}
                    />
                </Col>

                <Col span={24}>
                    <Spinner loading={loading.menu} />

                    <div style={{margin: '10px 0 20px 0' }}>
                        {menu.weeks && menu.weeks.map(w => (
                            <Tag key={w} color="volcano">v{w}</Tag>
                        ))}
                    </div>

                    {menu.origin._embedded['varma:days'].data.length === 0 && (
                        <Alert showIcon type="info" message="Menyn saknar måltider. Du kan lägga till måltider från recept." /> 
                    )}
                    {menu.origin._embedded['varma:days'].data.length > 0 && <Week menu={menu.origin} loading={loading.menu} />}
                </Col>
            </Row>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/dashboard/components/menu/CustomerMenu.js